// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMenu_wrapper__YvbMI"};